import { FC } from 'react';
import { TableBody } from '@digdir/designsystemet-react';

import { StyledTable } from '../../../../../expertRegistration/json/enhet/upload/fileReview/components/styledComponents';
import { TekniskUtstyr } from '../../../../../../types/registration/userInput';

import { OppvarmingElektriskView } from './elektrisk';
import { OppvarmingFjernvarmeView } from './fjernvarme';
import { OppvarmingBioEnergiView } from './bioenergi';
import { OppvarmingGassView } from './gass';
import { OppvarmingOljeView } from './olje';
import { OppvarmingSolfangerView } from './solfanger';
import { OppvarmingVedView } from './ved';
import { OppvarmingVarmepumpeView } from './varmepumpe';

interface TekniskutstyrProps {
  data: TekniskUtstyr;
}
export const TekniskUtstyrView: FC<TekniskutstyrProps> = ({ data }) => {
  const hasRomoppvarming = !!(
    data.oppvarmingElektrisk ||
    data.oppvarmingFjernvarme ||
    data.oppvarmingBioenergi ||
    data.oppvarmingGass ||
    data.oppvarmingOlje ||
    data.oppvarmingVed ||
    data.oppvarmingSol ||
    data.oppvarmingVarmepumpe
  );
  return (
    hasRomoppvarming && (
      <StyledTable>
        <TableBody>
          <OppvarmingElektriskView elektrisk={data.oppvarmingElektrisk} />
          <OppvarmingFjernvarmeView fjernvarme={data.oppvarmingFjernvarme} />
          <OppvarmingBioEnergiView bioenergi={data.oppvarmingBioenergi} />
          <OppvarmingGassView gass={data.oppvarmingGass} />
          <OppvarmingOljeView olje={data.oppvarmingOlje} />
          <OppvarmingSolfangerView solfanger={data.oppvarmingSol} />
          <OppvarmingVedView ved={data.oppvarmingVed} />
          <OppvarmingVarmepumpeView varmepumpe={data.oppvarmingVarmepumpe} />
        </TableBody>
      </StyledTable>
    )
  );
};
